import React from 'react';
import { useAuth } from '../context/AuthContext';
import config from '../config.json';

const AuthPage = () => {
  const { login, authError } = useAuth();

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>{config.page_title}</h2>
        <p>Please log in with your Discord account to access the gym tracker.</p>
        
        <button onClick={login} className="discord-login-btn">
          <i className="fa fa-discord"></i> Login with Discord
        </button>
        
        {authError && (
          <div className="auth-error">
            <p>{authError}</p>
          </div>
        )}
        
        <div className="auth-info">
          <p>You need to be a member of the required Discord server with the appropriate role.</p>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;